import { Component, HostListener } from "@angular/core";
//import { trigger, state, style, transition, animate } from '@angular/animations';

import { SlideInOutAnimation } from "../../../animations";
import { menuTopAnimation } from "../../../animations";
import { menuBottomAnimation } from "../../../animations";
import { navMenuAnimation } from "../../../animations";
import { navCloseAnimation } from "../../../animations";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  animations: [
    SlideInOutAnimation,
    menuTopAnimation,
    menuBottomAnimation,
    navMenuAnimation,
    navCloseAnimation,
  ],
})
export class HeaderComponent {
  constructor() {}
  menuState: string = "in";

  toggleMenu(divName: string) {
    if (divName === "overlay, menu-top, menu-bottom, nav-menu, nav-close") {
      this.menuState = this.menuState === "out" ? "in" : "out";
      console.log(this.menuState);
    }
  }
  isSticky = false;

  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.isSticky = window.pageYOffset > 100;
  }

  classActive = false;

  toggleClass() {
    this.classActive = !this.classActive;
  }

  ngOnInit() {}
}
